import Grid2 from '@mui/material/Unstable_Grid2';

import type { HighlightMediaTextProps } from '@/components/HighlightMediaText/HighlightMediaTextFull/HighlightMediaTextFull';
import TextContent from '@/components/HighlightMediaText/TextContent/TextContent';
import ArtDirectedImage from '@/components/Image/ArtDirectedImage';
import GridContainer2 from '@/components/Layout/GridContainer2/GridContainer2';
import { SpacingContainer } from '@/components/SpacingContainer/SpacingContainer';
import VimeoVideo from '@/components/VimeoVideo/VimeoVideo';
import type { FeaturedComponent } from '@/contentful';

import useStyles from './HighlightMediaTextFiftyFifty.styles';

const HighlightMediaTextFiftyFifty = ({
  imageSources,
  mobileImageAspectRatio,
  video,
  isOnDark,
  isRightAligned,
  subhead,
  cta,
  features,
  isHeroMode,
  eyebrow,
  headline,
  isFeatured,
  imageAltText,
  appLinks,
  ...props
}: FeaturedComponent<HighlightMediaTextProps>) => {
  const { classes, cx } = useStyles({ isOnDark, mobileImageAspectRatio });

  const videoFields = video?.fields;

  return (
    <SpacingContainer className={classes.container} isFeatured={isFeatured}>
      <GridContainer2 fixed>
        <div className={cx(classes.wrapper, !isRightAligned && 'invert')}>
          <Grid2 lg={6} md={6} sm={12} xs={12}>
            {video && videoFields?.videoUrl ? (
              <VimeoVideo
                url={videoFields.videoUrl}
                thumbnailSources={imageSources}
                autoplay={videoFields.autoPlay}
                controls={!videoFields.autoPlay}
                isRounded
              />
            ) : (
              imageSources && (
                <ArtDirectedImage
                  images={imageSources}
                  alt={imageAltText || ''}
                  className={classes.halfImage}
                />
              )
            )}
          </Grid2>
          <TextContent
            subhead={subhead}
            features={features}
            cta={cta}
            isHeroMode={isHeroMode}
            eyebrow={eyebrow}
            headline={headline}
            isOnDark={isOnDark}
            appLinks={appLinks}
            gridSizes={{ lg: 6, md: 6, sm: 12, xs: 12 }}
            {...props}
          />
        </div>
      </GridContainer2>
    </SpacingContainer>
  );
};

export default HighlightMediaTextFiftyFifty;
